import {z} from 'zod';

export const runfileIdentificationSchema = z
    .object({
        specificIdentificationOn: z.boolean().optional(),
        specificIdentificationLabel: z.string().optional(),
        groupIdentificationOn: z.boolean().optional(),
        groupIdentificationLabel: z.string().optional(),
        options: z.array(z.string()).optional(),
    })
    .refine((data) => !(data.groupIdentificationOn && !data.groupIdentificationLabel), {
        message: 'roomsPage.error.groupIdentificationLabel',
        path: ['groupIdentificationLabel'],
    })
    .refine((data) => !(data.groupIdentificationOn && data.options && data.options.length === 0), {
        message: 'roomsPage.error.options',
        path: ['options'],
    })
    .refine((data) => !(data.specificIdentificationOn && !data.specificIdentificationLabel), {
        message: 'roomsPage.error.specificIdentificationLabel',
        path: ['specificIdentificationLabel'],
    });
